import { render, staticRenderFns } from "./CustomDutyItem.vue?vue&type=template&id=51da4b71&scoped=true&"
import script from "./CustomDutyItem.vue?vue&type=script&lang=ts&"
export * from "./CustomDutyItem.vue?vue&type=script&lang=ts&"
import style0 from "./CustomDutyItem.vue?vue&type=style&index=0&id=51da4b71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51da4b71",
  null
  
)

export default component.exports